var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { shadowElevation2 } from '@hn-ui/themes';
import { styled } from 'styled-components';
import { Text, Title, } from '../../../../supervizors/components/marathons/Common';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-jinevr" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  border-radius: 16px;\n  background: ", ";\n  ", "\n  padding: 32px;\n  gap: 8px;\n"], ["\n  display: flex;\n  flex-flow: column;\n  border-radius: 16px;\n  background: ", ";\n  ", "\n  padding: 32px;\n  gap: 8px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black100;
}, shadowElevation2);
var NoMarathons = function (_a) {
    var rest = __rest(_a, []);
    return (_jsxs(Container, __assign({}, rest, { children: [_jsx(Title, { children: "Math Challenge not scheduled yet!" }, void 0), _jsx(Text, { children: "Connect with your school admin to organize it within your school." }, void 0)] }), void 0));
};
export { NoMarathons };
var templateObject_1;
